import styled from 'styled-components';

function Process() {
  return (
    <Container>
      <Card $color="#E9FAFA">
        <StepBox>STEP 01</StepBox>
        <Content>
          <Title>NPL 등록</Title>
          <Desc>간편한 파일 업로드로 NPL정보를 등록합니다.</Desc>
        </Content>
      </Card>
      <Card $color="#D7F6F6">
        <TriangleWrapper>
          <Triangle color="#E9FAFA" />
        </TriangleWrapper>
        <StepBox>STEP 02</StepBox>
        <Content>
          <Title>AI 분석</Title>
          <Desc>
            AI가 자동으로 리포트를 생성하고
            <br />
            가치를 분석합니다.
          </Desc>
        </Content>
      </Card>
      <Card $color="#BCF0F0">
        <TriangleWrapper>
          <Triangle color="#D7F6F6" />
        </TriangleWrapper>
        <StepBox>STEP 03</StepBox>
        <Content>
          <Title>매수의향서 제출</Title>
          <Desc>
            매입사는 자금 증빙과 함께
            <br />
            매수 의향서를 제출합니다.
          </Desc>
        </Content>
      </Card>
      <Card $color="#A6EBEC">
        <TriangleWrapper>
          <Triangle color="#BCF0F0" />
        </TriangleWrapper>
        <StepBox>STEP 04</StepBox>
        <Content>
          <Title>비공개 가격 협의</Title>
          <Desc>
            플랫폼의 중개를 통해 안전하게
            <br />
            가격을 협의합니다.
          </Desc>
        </Content>
      </Card>
      <Card $color="#8FE6E7">
        <TriangleWrapper>
          <Triangle color="#A6EBEC" />
        </TriangleWrapper>
        <StepBox>STEP 05</StepBox>
        <Content>
          <Title>거래 성사</Title>
          <Desc>
            법률/행정 절차 지원과 함께
            <br />
            최종 거래를 완료합니다.
          </Desc>
        </Content>
      </Card>
    </Container>
  );
}

export default Process;

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const Card = styled.div<{ $color: string }>`
  position: relative;
  display: flex;
  width: 100%;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  background: ${({ $color }) => $color};

  &:first-child {
    border-radius: 12px 12px 0 0;
  }

  &:last-child {
    padding: 40px 20px 20px 20px;
    border-radius: 0 0 12px 12px;
  }
`;

const StepBox = styled.div`
  display: flex;
  padding: 3px 6px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #1a7c83;
  color: #f2ffff;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const Title = styled.div`
  color: #000;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 29px */
  letter-spacing: -0.4px;
`;

const Desc = styled.div`
  color: #042b2e;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.48px;
`;

const TriangleWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
`;

const Triangle = ({ color }: { color: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="328"
      height="20"
      viewBox="0 0 328 20"
      fill="none"
    >
      <path d="M328 0L164 20L0 -1.43373e-05L328 0Z" fill={color} />
    </svg>
  );
};
